import { getManagementApiBaseUrl } from '../../utils/management-api';
import { id } from '@monorepo/tools/src/lib/types/primitives';

export class DestinationsEndpoint {
	private baseUrl: string;

	constructor() {
		this.baseUrl = `${getManagementApiBaseUrl()}/destination`;
	}

	list() {
		return `${this.baseUrl}/`;
	}

	get(destinationId: id) {
		return `${this.baseUrl}/${destinationId}`;
	}

	create() {
		return `${this.baseUrl}/`;
	}

	edit(destinationId: id) {
		return `${this.baseUrl}/${destinationId}`;
	}

	listCreatives(destinationId: id) {
		return `${this.baseUrl}/${destinationId}/creatives`;
	}

	addCreative(destinationId: id) {
		return `${this.baseUrl}/${destinationId}/creatives/`;
	}

	removeCreative(destinationId: id, creativeId: id) {
		return `${this.baseUrl}/${destinationId}/creatives/${creativeId}`;
	}
}
